module.exports = __webpack_public_path__ + "static/media/my-centrum-bg.847cbad9.png";